/**
 * Canonical listing category keys (seller create/edit, home “more” sheet, store categories).
 * Keep in sync with iOS ListingCategories / Android ListingCategoriesData.
 */
export const LISTING_CATEGORY_KEYS: readonly string[] = [
  'antiques',
  'appliances',
  'arts+crafts',
  'atv/utv/sno',
  'auto parts',
  'aviation',
  'baby+kid',
  'barter',
  'beauty+hlth',
  'bike parts',
  'bikes',
  'boat parts',
  'boats',
  'books',
  'business',
  'cars+trucks',
  'cds/dvd/vhs',
  'cell phones',
  'clothing',
  'collectibles',
  'computer parts',
  'computers',
  'electronics',
  'farm+garden',
  'food',
  'free',
  'furniture',
  'garage sale',
  'general',
  'heavy equip',
  'household',
  'jewelry',
  'materials',
  'motorcycle parts',
  'motorcycles',
  'music instr',
  'pets',
  'photo+video',
  'rvs+camp',
  'shop',
  'sporting',
  'tickets',
  'tools',
  'toys+games',
  'trailers',
  'video gaming',
  'wanted',
  'wheels+tires',
] as const;

const CLOTHING_LEGACY = new Set(['clothes', 'clothes+acc']);

export function normalizeListingCategory(category: string | null | undefined): string {
  if (category == null) return 'general';
  const key = String(category).trim();
  if (!key) return 'general';
  if (CLOTHING_LEGACY.has(key)) return 'clothing';
  return key;
}

export function resolveListingCategory(category: string | null | undefined): string {
  const key = normalizeListingCategory(category);
  return (LISTING_CATEGORY_KEYS as readonly string[]).includes(key) ? key : 'general';
}

export function formatListingCategoryLabel(category: string): string {
  return category
    .replace(/\+/g, ' ')
    .replace(/\//g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
